<!--
 * @Author: your name
 * @Date: 2021-08-15 17:23:15
 * @LastEditTime: 2022-03-02 02:41:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/components/UploadImgs.vue
-->
<template>
  <div class="upload-imgs">
    <div v-if="disabled" class="occlude"></div>
    <van-uploader
      v-model="imgs"
      :max-count="max"
      :before-delete="delImgs"
      :after-read="uploadImgs"
      v-bind="$attrs"
      :preview-full-image="false"
      @click-preview="preview"
      class="uploader"
    >
      <template v-if="$slots.default">
        <slot></slot>
      </template>
    </van-uploader>
  </div>
</template>
<script>
import { Toast, ImagePreview } from "vant";
import Compressor from "compressorjs";
export default {
  name: "UploadImgs",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 0,
    },
    fileKey: {
      type: String,
      default: "img",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list: {
      handler(newVal) {
        if (newVal) {
          this.imgs = newVal;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      imgs: [],
    };
  },
  methods: {
    compressor(file, quality = 0.2) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality,
          success: resolve,
          error: reject,
        });
      });
    },
    /*上传图片*/
    async uploadImgs(file) {
      let data = new FormData();
      const img = await this.compressor(file.file);

      data.append(this.fileKey, img);

      for (const key in this.data) {
        if (Object.hasOwnProperty.call(this.data, key)) {
          data.append(key, this.data[key]);
        }
      }

      file.status = "uploading";
      file.message = "上传中...";

      try {
        const {
          data: { id, imgName, imgUrl, imgHost },
        } = await this.$api.common.uploadImage(data);

        file.id = id;
        file.imgName = imgName;
        file.imgUrl = imgUrl;
        file.imgHost = imgHost;

        file.status = "done";
      } catch (error) {
        this.imgs = this.imgs.filter((item) => item !== file);
      }
    },
    /*点击删除图片*/
    async delImgs(file) {
      try {
        await this.$api.common.deleteImage({
          ...this.data,
          id: file.id,
        });
      } catch (error) {
        Toast.fail("删除失败");
        return Promise.reject();
      }
    },
    /* 点击预览图片 */
    preview(file) {
      ImagePreview({
        images: [file.content || file.url],
        closeable: true,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.upload-imgs {
  position: relative;
  margin-top: 10px;

  .occlude {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    z-index: 30;
  }

  .uploader {
    z-index: 0 !important;
  }
}
</style>
<style>
.van-uploader__preview-delete {
  width: 20px;
  height: 20px;
}

.van-uploader__preview-delete-icon {
  font-size: 22px;
}
</style>
